import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { Stack } from 'rsuite'

import Avatar from '../../Avatar/Avatar'
import useDefaultProductSpecialist from '../../../services/strapi/useDefaultProductSpecialist'
import { getStrapiMediaUrl } from '../../../utils/strapi'
import MarketingBannerButtonBase from '../../Buttons/MarketingBannerButtons/MarketingBannerButtonBase'

import styles from '../../../styles/Banner.module.less'

const ProductExpertBanner: FC = () => {
  const { t } = useTranslation('products')

  const productSpecialist = useDefaultProductSpecialist()
  const productSpecialistImagePath = getStrapiMediaUrl(productSpecialist?.attributes.profilePicture)
  const productSpecialistName = productSpecialist?.attributes?.name || '---'

  return (
    <Stack direction="column">
      <Avatar
        imageSrc={productSpecialistImagePath ?? ''}
        altName={`${t('Product expert')} / ${productSpecialistName}`}
        size="lg"
      />
      <p className={styles['expert-name']}>
        <span>{productSpecialistName}</span>
        {' / '}
        <b>
          {t('modals:Customer service')}
        </b>
      </p>
      <MarketingBannerButtonBase className="margin-bottom-spacer-tripple">
        <a href={`tel:${productSpecialist?.attributes.phone}`}>
          {productSpecialist?.attributes.phone}
        </a>
      </MarketingBannerButtonBase>
    </Stack>
  )
}

export default ProductExpertBanner
